import {IEnvironment} from './IEnvironment';

export const environment: IEnvironment = {
  production: false,
  auth: {
    clientId: '14f07756-b759-4d57-8b18-e2896e78bf10',
    authority: 'https://login.microsoftonline.com/8d4b558f-7b2e-40ba-ad1f-e04d79e6265a',
    redirectUri: 'https://dev.finops.contitech.cloud/',
    postLogoutRedirectUri: '/'
  },
  apiUri: 'https://api.dev.finops.contitech.cloud'
};
